import {Component} from '@angular/core';
import {AccessRequest} from '../models/access-request';
import {Observable} from 'rxjs/Observable';
import * as fromRoot from '../reducers';
import * as actions from '../actions/register';
import {Store} from '@ngrx/store';

@Component({
  selector: 'app-admin-access-requests',
  template: `<div>
    <h2>Access Requests</h2>
    <access-request-controls [requestType]="requestType$| async" (loadRequests)="loadRequests($event)"></access-request-controls>
    <access-request-list [requests]="requests$ | async"
                         [approveId]="approveId$ | async"
                         [denyId]="denyId$ | async"
                         (approveRequest)="approveRequest($event)" 
                         (denyRequest)="denyRequest($event)"></access-request-list>
  </div>
  `
})
export class AdminAccessRequestsPageComponent {

  public requestType$: Observable<string>;
  public requests$: Observable<AccessRequest[]>;
  public approveId$: Observable<number>;
  public denyId$: Observable<number>;

  constructor(private store: Store<fromRoot.State>) {
    this.requestType$ = this.store.select(fromRoot.getRequestType);
    this.requests$ = this.store.select(fromRoot.getRequestList);
    this.approveId$ = this.store.select(fromRoot.getRequestApproveId);
    this.denyId$ = this.store.select(fromRoot.getRequestDenyId);
    this.store.dispatch(new actions.LoadAccessRequestsAction('PENDING'));
  }

  public approveRequest(accessRequest: AccessRequest) {
    this.store.dispatch(new actions.ApproveAccessRequestAction(accessRequest));
  }

  public denyRequest(accessRequest: AccessRequest) {
    this.store.dispatch(new actions.DenyAccessRequestAction(accessRequest));
  }

  loadRequests (e: string) {
    this.store.dispatch(new actions.LoadAccessRequestsAction(e));
  }
}



// WEBPACK FOOTER //
// C:/Users/jstan/Projects/usda-document-client/src/app/modules/core/containers/admin-access-requests.ts